module.exports = __webpack_public_path__ + "static/img/VDadvantage2.e8be68d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/VDadvantage2.png
// module id = V164
// module chunks = 0